import cloneDeep from 'lodash/cloneDeep';
import { AvatarPropertiesSetSchema, DEFAULT_AVATAR_PROPERTIES_SET } from '../../../../types/avatarTypes';
import { uuid } from '../../../../utils/utils';
import { parseInboundPayload } from '../../inbound';
import { encodedStringParser, numberParser } from '../../inboundParsers';
import { trimBraces } from '../../inboundUtils';
// TODO: Add zod (schema) validation.
export function playerAvatarParser(str) {
    const { avatarJson, faceNum } = inboundPlayerAvatarParser(str);
    if (avatarJson) {
        return {
            type: 'custom',
            uuid: uuid(),
            avatar: avatarPropertiesSetParser(avatarJson)
        };
    }
    if (faceNum <= 1) {
        // Probably set to a Meez avatar (URL) if -1, or default legacy avatar if 1, use new custom as default:
        return {
            type: 'custom',
            uuid: uuid(),
            avatar: cloneDeep(DEFAULT_AVATAR_PROPERTIES_SET)
        };
    }
    return {
        type: 'legacy',
        uuid: uuid(),
        faceNum: faceNum > 0 ? faceNum : 1
    };
}
export function optionalAvatarPropertiesSetParser(str) {
    if (!str) {
        return;
    }
    return avatarPropertiesSetParser(str);
}
export function avatarPropertiesSetParser(str) {
    try {
        const obj = JSON.parse(str);
        AvatarPropertiesSetSchema.parse(obj);
        return obj;
    }
    catch {
        return cloneDeep(DEFAULT_AVATAR_PROPERTIES_SET);
    }
}
export function optionalPlayerAvatarParser(str) {
    if (!str) {
        return undefined;
    }
    return playerAvatarParser(str);
}
function inboundPlayerAvatarParser(str) {
    const inboundParts = trimBraces(str).split(',');
    return parseInboundPayload(inboundParts, inboundPlayerAvatarPartDefinitions);
}
const inboundPlayerAvatarPartDefinitions = [
    { name: 'faceNum', parser: numberParser },
    { name: 'rgbNum', parser: numberParser },
    { name: 'faceVariationNum', parser: numberParser },
    { name: 'meezUrl', parser: encodedStringParser },
    { name: 'avatarJson', parser: encodedStringParser }
];
export function encodedPlayerAvatarParser(str) {
    return playerAvatarParser(encodedStringParser(str));
}
